import { render, staticRenderFns } from "./QuizBankAdd.vue?vue&type=template&id=034e1f6c&scoped=true"
import script from "./QuizBankAdd.vue?vue&type=script&lang=js"
export * from "./QuizBankAdd.vue?vue&type=script&lang=js"
import style0 from "./QuizBankAdd.vue?vue&type=style&index=0&id=034e1f6c&prod&scoped=true&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034e1f6c",
  null
  
)

export default component.exports